import { Controller } from "stimulus"

export default class extends Controller {

    toggleLabel(event) {
        if (event.target.value.length == 0) {
            event.target.previousSibling.previousSibling.classList.add("opacity-0");
            event.target.classList.remove("pt-4");
        } else {
            event.target.previousSibling.previousSibling.classList.remove("opacity-0");
            event.target.classList.add("pt-4");
        }
    }

}